import { SUID } from "./suid";

const EXIT_TIMEOUT = 3000;
export let timeoutToExit = null;

export const exitRedirect = reason => {
    if (window.noExitRedirect) return;

    const REDIRECT_URL = `/exit?suid=${SUID.value}&reason=${reason}`;

    timeoutToExit = setTimeout(() => {
        window.location = REDIRECT_URL;
    }, EXIT_TIMEOUT);
};